import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { DESK_QUERY } from "@/components/app/agent-pane/use-agent-pane";
import { useMedia } from "@/hooks/use-wide";
import { openPaneAgent } from "@/lib/workspace/agent-pane";
import { guardFeature } from "@/lib/policy/route-guard";
import { useKitchen } from "./-lib/use-kitchen";

/* The Kitchen agent was a tab here; it is in the right-hand pane now. An old link (`c` is the
   conversation) opens the calendar with the agent beside it, on that conversation. */
export const Route = createFileRoute("/_authenticated/menus/agent")({
  validateSearch: (search: Record<string, unknown>): { c?: string } =>
    typeof search.c === "string" && search.c ? { c: search.c } : {},
  beforeLoad: ({ context }) => guardFeature(context.me, "menu-agent"),
  component: MenuAgentLink,
});

function MenuAgentLink() {
  const { c } = Route.useSearch();
  const navigate = useNavigate();
  const desk = useMedia(DESK_QUERY);
  const { facilityId } = useKitchen();
  useEffect(() => {
    /* With no one kitchen picked there is nowhere to file the conversation, so it is dropped. */
    openPaneAgent(
      "menus",
      desk,
      facilityId
        ? { threadKey: `menus:${facilityId}`, threadId: c, arriving: true }
        : { arriving: true },
    );
    void navigate({ to: "/menus/calendar", replace: true });
  }, [c, desk, facilityId, navigate]);
  return null;
}
